<template>
  <v-container class="cmpbk black--text" id="home-container">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2025, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
   <template>
      <div style="width:100%;background-color: rgb(48, 48, 48);"> 
    <h2 class="ml-4 white--text" style="width:100%;background-color: rgb(48, 48, 48);">Forgot Password</h2>
    <hr>
  </div>
    <v-stepper v-model="steep" alt-labels :mobile="false" id="stepper" >
    <v-stepper-header>
      <v-stepper-step
        :complete="steep > 1"
        step="1"
      >
        Enter Email
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step
        :complete="steep > 2"
        step="2"
      >
        Security Question
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="3">
       Create Password
      </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-card>
          <template>
            <v-form
            style="height: auto;"
            dark
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-text-field
            color="grey lighten-2"
                class="mt-4 mb-4 pa-1"
                dark
                v-model="email"
                :rules="emailRules"
                label="Email"
                required
                outlined
              ></v-text-field>
            </v-form>
          </template
    > </v-card>
<v-row dense>
  <v-col cols="12" md="2">
  <v-btn
    class="mt-4 ca-btn"
    color="primary"
    @click="submit_email_recover"
    >
    Continue
  </v-btn>
</v-col>
 <v-col cols="12" md="3">
    <v-btn
    class="mt-4 ca-btn"
    color="primary"
    @click="cancel"
    >
    Cancel
    </v-btn>
</v-col>

</v-row>

      </v-stepper-content>

<v-stepper-content step="2">
  
<v-card style="width:100%;background-color: rgb(48, 48, 48);" >
  <template>
    <p>Answer a security question to reset your password.</p>
    <p><b><i>{{question}}</i></b></p>
  

    <v-form
      style="height: auto;"
      dark
      ref="form2"
      v-model="valid2"
      lazy-validation
    >
  <!-- :append-icon="showeye ? 'mdi-eye-off' : 'mdi-eye'"  style="position: relative;top: -91px; left: 911px;" -->
        <v-text-field
          required
          color="grey lighten-2"
          class="mt-4 mb-4 pa-1"

          v-model="answer"

          label="Answer"
          clearable
          outlined        
      ></v-text-field> 

    </v-form>
    <v-row dense> 
       <v-col cols="12" md="3" sm="3" >
          <v-btn 
      class="pa-2 mt-4 ca-btn"
      color="primary"
      @click="submit_answer"
      >
      Submit Answer
      </v-btn>
    </v-col>
    <v-col cols="12" md="3" sm="3" >
    <v-btn  class="pa-2 mt-4 ca-btn" text @click="steep=1" >
      Cancel
    </v-btn>
    </v-col>
  </v-row>



  </template>
        </v-card>


      </v-stepper-content>

      <v-stepper-content step="3" >
        <v-card
        dark>
           <v-card-text dark>
      <h4>Now its time to create your RPD Portal compliant password.
          This password must be at least 8 characters in length and
          contain at least (1) Upper Case Letter + (1) Lower Case Letter + (1) Number and (1) Symbol !@@#$%^&.</h4>    
    
    <v-form
      style="height: auto;"
      dark
      ref="form3"
      v-model="valid3"
      lazy-validation
    ><v-row dense style="width:100%">
      <v-col cols="12" md="6" sm="6">        <v-text-field
          required
          color="grey lighten-2"
          class="mt-4 mb-4 pa-1"
        :append-icon="showeye ? `$eyeoff` : `$eye`" 
        @click:append="toggle_eye"
        :type="showeye ? 'text' : 'password'"
          v-model="password"
          :rules="passwordRules"
          label="Password"
          clearable
          outlined        
      ></v-text-field> 
    </v-col>
       <v-col cols="12" md="6" sm="6">   
            <v-text-field
          required
          color="grey lighten-2"
          class="mt-4  pa-0"
        :append-icon="showeye ? `$eyeoff` : `$eye`" 
        @click:append="toggle_eye"
        :type="showeye ? 'text' : 'password'"
          v-model="password2"

          label="Match password"
          clearable
          outlined        
      ></v-text-field> 
    </v-col>
    </v-row>
  <!-- :append-icon="showeye ? 'mdi-eye-off' : 'mdi-eye'"  style="position: relative;top: -91px; left: 911px;" -->
    </v-form>

  </v-card-text>
  <v-card-actions>  
      <v-row dense>
      <v-col cols="12" md="3" sm="3" >
        <v-btn  class="mt-4 ca-btn"    color="primary"  @click="setNewPassword">
        Submit Password
        </v-btn>
      </v-col>
      <v-col cols="12" md="3" sm="3" >
        <v-btn text class="mt-4 white--text ca-btn"      @click="steep = 2">
          Back
        </v-btn>
     
      </v-col>
    </v-row>

 </v-card-actions>
      </v-card>



      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
   </template>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
.grow-stepper .v-stepper__wrapper,
.grow-stepper .v-stepper__items {
  height: auto !important;     /* remove the inline 160 px */
}
.grow-stepper .v-stepper__content {
  max-height: none !important; /* kill the default 600 px cap */
}

.ca-btn{
  width:100%;
}
@media (min-width: 768px) {
  
.ca-btn{
  width: 170px;
  }
}

@media only screen and (max-width: 959.98px) {}

.v-stepper:not(.v-stepper--vertical) .v-stepper__label {
    display: block !important;
}

</style>

<script>
/* eslint-disable */
/* global document */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "forgot",
  mixins: [bus_common],
  data() {
        const pwdRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{8,}$/;
    return {
      showeye:false,
      code:"",
      cnt:1,
      valid3:"",
      answer:"",
      question:"",
      showeye:false,
      password2:"",
      password:"",
      valid2:true,
      valid:true,
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      passwordRules: [
        v => !!v || 'Password is required',
        v => pwdRegex.test(v) ||
              'Min 8 · 1 upper · 1 lower · 1 digit · 1 symbol (!@#$%^&*)'
      ],
      steep: 1,
    }
  },
  methods: {
toggle_eye(){
  this.showeye=!this.showeye;
},
  setNewPassword() {
       console.log("submit_password");

      if (this.password != this.password2) {
              this.swall_it("Password Status", "Passwords must match.", "warning", null, null);
              return true
      }
      this.show_loader(true);
      var formIn = {};
      formIn.count = parseInt( this.code);
      formIn.check = this.password;

      formIn.apiname = "setNewPassword";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
                    this.show_loader(false);

          if (data.msg.indexOf("Your email was not found") > -1) {
                      this.swall_it("Password Status", "Your email was not found.  Password not set.", "error", null, null);
                      self.cnt++;
                      return true;
          }
                    if (data.msg.indexOf("Server error") > -1) {
                      this.swall_it("Password Status", "Server error. Password not set. Please try again.", "error", null, null);
                      self.cnt++;
                      return true;
          }
          //sucess
           this.swall_it("Password Status", "Password set. Reload page to log in. " + data.msg, "sucess", null, null);

          

  
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Answer", msg, "error", null, null);
        });
    },
  submit_answer() {
       console.log("submit_answer");


      this.show_loader(true);
      var formIn = {};
      formIn.email = this.email;
      formIn.answer = this.answer;

      formIn.apiname = "submit_answer";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
                    this.show_loader(false);
          if (self.cnt == 3) {
                this.swall_it("Email Status", "You have exceeded the number of tries to answer a security question. Reload this page to try again.", "warning", null, null);
                self.steep = 1;

            return true;
          }
          if (data.msg.indexOf("incorrect") > -1) {
                      this.swall_it("Email Status", "Unfortunately, your answer to the security question is incorrect. You are allowed three tries.", "warning", null, null);
                      self.cnt++;
                      return true;
          }else{
            self.code = self.mno(data.msg);
            self.steep = 3;
          }

  
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Answer", msg, "error", null, null);
        });
    },
  submit_email_recover() {
       console.log("submit_email_recover");
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.email;


      formIn.apiname = "submit_email_recover";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
                    this.show_loader(false);
          if (data.msg.indexOf("not found") > -1) {
                this.swall_it("Email Status", "Email not found. Please register.", "warning", null, null);
                return true;
          }else{
            self.question = self.mno(data.msg);
            self.steep = 2;
          }

  
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Email", msg, "error", null, null);
        });
    },
    cancel(){
      this.$emit('forgot_quit');
    },
    checkemail() {
       console.log("checkmail");


      this.show_loader(true);
      var formIn = {};
      formIn.email = this.email;

      formIn.apiname = "checkemail";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
                    this.show_loader(false);
          if (data.msg == "found") {
                    self.steep = 2;
          }else{
           this.swall_it("Email Status", "Enail not found. Please register.", "warning", null, null);
          }

  
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Email", msg, "error", null, null);
        });
    },
    message1() {
      alert("This button does nothing yet.");
    },
    init() {},
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
